const moment = require("moment");
import Player from "source/app/domain/Player";

export function DreamTimePeriodText(difficulty: number) {
    const dreamTime = dreamTimes.find((dt) => dt.difficulty === difficulty)!;

    const targetDateText = moment()
        .add(dreamTime.timeInYears, "years")
        .format("MMM YYYY");

    const targetAgeText = moment()
        .add(dreamTime.timeInYears, "years")
        .diff(Player.birthday, "years");

    return `in ${dreamTime.fullName} | ${targetDateText} | Age ${targetAgeText}`;
}

export function ConvertDifficultyToDreamTime(difficulty: number) {
    if (!difficulty) {
        return dreamTimes[0];
    }

    return dreamTimes.find((dt) => dt.difficulty === difficulty)!;
}

export function DreamTimesDoNotHave(difficulty: number) {
    const hasDifficulty =
        dreamTimes.findIndex((dt) => dt.difficulty === difficulty) === -1;
    return hasDifficulty;
}

const soonDreamTimeBase = {
    shortName: "now",
    fullName: "a short time",
    hexColor: "#ffffff",
    timeInYears: 0.0416666666666667,
};

export const dreamTimes: IDreamTime[] = [
    {
        difficulty: 0,
        ...soonDreamTimeBase,
        hexColor: "#000000",
    },
    {
        difficulty: 1,
        ...soonDreamTimeBase,
        hexColor: "#ff7d91",
    },
    {
        difficulty: 2,
        ...soonDreamTimeBase,
        hexColor: "#ff81c0",
    },
    {
        difficulty: 3,
        ...soonDreamTimeBase,
        hexColor: "#e78aa0",
    },
    {
        difficulty: 4,
        ...soonDreamTimeBase,
        hexColor: "#FF9671",
    },
    {
        difficulty: 5,
        shortName: "2w",
        fullName: "2 weeks",
        hexColor: "#FFC75F",
        timeInYears: 0.0416666666666667,
    },
    {
        difficulty: 6,
        shortName: "6m",
        fullName: "6 months",
        hexColor: "#F9F871",
        timeInYears: 0.5,
    },
    {
        difficulty: 7,
        shortName: "1.5y",
        fullName: "1.5 years",
        hexColor: "#94d9d9",
        timeInYears: 1.5,
    },
    {
        difficulty: 8,
        shortName: "3y",
        fullName: "3 years",
        hexColor: "#90b1ff",
        timeInYears: 3,
    },
    {
        difficulty: 9,
        shortName: "5y",
        fullName: "5 years",
        hexColor: "#bf98ff",
        timeInYears: 5,
    },
    {
        difficulty: 10,
        shortName: "10y",
        fullName: "10 years",
        hexColor: "#ababab",
        timeInYears: 10,
    },
    {
        difficulty: 11,
        shortName: "20y",
        fullName: "20 years",
        hexColor: "#b1b1b1",
        timeInYears: 20,
    },
];

export interface IDreamTime {
    difficulty: number;
    shortName: string;
    fullName: string;
    timeInYears: number;
    hexColor: string;
}
